// extracted by mini-css-extract-plugin
module.exports = {"heading":"_29L0iiCgN91OYT0cdOVRgX","buttonContainer":"_3w9E-QH_lCpmUFiyKJuKV8","extraAction":"m6lEkDXg9FeRm52S73dph"};